const LIQUIDATOR_T = {
    form_project_0: "Tipo de proyecto",
    form_project_1: "Licencia de Reconocimiento y Construcción",
    form_project_2: "Licencia de Urbanización",
    form_project_3: "Reconocimiento de edificación",
    form_project_4: "Licencia de Subdivisión",
    form_project_5: "Licencia de Parcelación",
    form_project_6: "Licencia de Intervención y Ocupación del espacio público",
    form_use_0: "Tipo de uso",
    form_use_1: "Vivienda",
    form_use_2: "Otros Usos (Comercio, Servicios, Insitucional, Industrial)",
    form_social_0: "Tipo de vivienda",
    form_social_1: "Vivienda de Interés Social (VIS)",
    form_social_2: "NO Vivienda de Interés Social (NO VIS)",
    form_social_3: "Vivienda de Interés Social Prioritaria (VIP)",
    form_strata_0: "Estrato",
    form_strata_1: "Estrato 1 y 2",
    form_strata_2: "Estrato 3",
    form_strata_3: "Estrato 4",
    form_strata_4: "Estrato 5",
    form_strata_5: "Estrato 6",
    form_area: "Area",
    form_module_0: "Modalidad o tipo de actuación",
    form_module_1: "OBRA NUEVA",
    form_module_2: "AMPLIACIÓN",
    form_module_3: "MODIFICACIÓN",
    form_module_31: "MODIFICACIÓN (SOLAMENTE)",
    form_module_4: "REFORZAMIENTO ESTRUCTURAL",
    form_module_5: "ADECUACIÓN (CON OBRAS)",
    form_module_51: "ADECUACIÓN (SIN OBRAS)",
    form_module_6: "DEMOLICIÓN TOTAL",
    form_module_7: "DEMOLICIÓN PARCIAL",
    form_module_8: "CERRAMIENTO",
    form_module_9: "RESTAURACIÓN",
    form_module_10: "RECONSTRUCCIÓN",
    form_module_11: "RECONOCIMIENTO",
    form_btn: "Calcular",
    title: "Liquidador",
    subTitle_1: "Ingrese aquí sus datos",
    subTitle_2: "Resultados de expensas",
    text_21: "Cargo fijo",
    text_22: "Cargo variable",
    text_23: "Subtotal",
    text_24: "IVA",
    text_25: "Total",
    text_26: "Expensas",
}

export default LIQUIDATOR_T;